var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chips", attrs: { id: _vm.identifier } },
    _vm._l(_vm.preparedItems, function (item) {
      return _c(
        "BaseChip",
        {
          key: item.id,
          ref: "chip_" + item.id,
          refInFor: true,
          staticClass: "chips__item",
          attrs: {
            id: item.id,
            disabled: item.disabled,
            removable: item.removable,
          },
          on: {
            click: function ($event) {
              return _vm.onChipClick(item)
            },
            remove: function ($event) {
              return _vm.onChipRemove(item)
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "removeIcon",
                fn: function () {
                  return [
                    _vm._t("chipRemoveIcon", function () {
                      return [_vm._v("×")]
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm._t(
            "chipLabel",
            function () {
              return [
                _vm._v("\n            " + _vm._s(item.label) + "\n        "),
              ]
            },
            { item: item }
          ),
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }